export default __webpack_public_path__ + "static/media/030_corner1.b1e23188.mp4";